export const VGM_DATA_COLUMNS = [
  {
    Header: "ADD",
    accessor: "add_Data",
    width : 1
  },
  {
    Header: "MODULE",
    accessor: "DataOf",
    width : 1
  },
  {
    Header: "SHIPPER NAME",
    accessor: "Shipper_Authorised_Name",
  },
  {
    Header: "CONTAINER NO",
    accessor: "Container_Number",
  },
  {
    Header: "CONTAINER SIZE",
    accessor: "Container_Type",
  },
  {
    Header: "MAXIMUM PERMISSIBLE WEIGHT",
    accessor: "Container_Weight",
  },
  {
    Header: "VGM WEIGHT",
    accessor: "Container_Mass",
    width : 1
  },
  {
    Header: "WEIGHING DATE",
    accessor: "Weighing_Date",
    width : 1
  },
  {
    Header: "WEIGHING SLIP NO",
    accessor: "Weighing_Slip_No",
  },
  {
    Header: "TYPE",
    accessor: "VGM_Type",
    width : 1
  },
  {
    Header: "REMARK",
    accessor: "Remarks",
    width : 1
  },
  {
    Header: "GENERATE PDF",
    accessor: "generate_pdf",
    width : 1
  },
];